import { CircleQuestionMarkIcon } from 'lucide-react';
import AndroidIcon from '@/assets/platform-icons/android-icon-small.svg?react';
import IosIcon from '@/assets/platform-icons/apple-icon.svg?react';

type Props = {
  platform: 'ios' | 'android' | '';
};

const PLATFORMS = {
  ios: {
    icon: IosIcon,
    name: 'iOS',
  },
  android: {
    icon: AndroidIcon,
    name: 'Android',
  },
  '': {
    icon: CircleQuestionMarkIcon,
    name: 'Unknown',
  },
};

export const RequestPlatform = ({ platform }: Props) => {
  const platformData = PLATFORMS[platform] || PLATFORMS[''];

  return (
    <div className="flex items-center gap-2">
      <div className="flex size-6 items-center justify-center">
        <platformData.icon className="text-black dark:text-white" width={16} height={16} />
      </div>
      <span>{platformData.name}</span>
    </div>
  );
};
